export enum IgOnboardingTourType {
  CGT_PRODUCT_TOUR = 'CGT_PRODUCT_TOUR',
}
